import { render, staticRenderFns } from "./CourseTextAssignment.vue?vue&type=template&id=3732f5ac"
import script from "./CourseTextAssignment.vue?vue&type=script&lang=js"
export * from "./CourseTextAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports